/* istanbul ignore file */
import { boolean as codecBoolean, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { CourseRole } from './CourseRole';
const CourseRegistrationLinkParser = 
/* #__PURE__ */ parsers.object([
    ['id', codecString],
    ['expirationDate', parsers.moment, 'expiration_date'],
    ['role', CourseRole],
    ['allowRegister', codecBoolean, 'allow_register'],
]);
export class CourseRegistrationLink extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CourseRegistrationLinkParser.decode(input).map(res => new CourseRegistrationLink(res));
    }
    static unsafeDecode(input) {
        return CourseRegistrationLink.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CourseRegistrationLinkParser.encode(data);
    }
    static schema() {
        return CourseRegistrationLinkParser.schema();
    }
}
